import { defineComponent } from 'vue'
import { GfrGrid } from '#components'
import './index.scss'
export default defineComponent({
  name: 'ArticleCardWrapper',
  setup(_, { slots }) {
    return () => <GfrGrid class={'com-article-wrapper'}>{slots.default?.()}</GfrGrid>
  }
})
